import { render } from "./DataLoading.vue?vue&type=template&id=ab537460"
import script from "./DataLoading.vue?vue&type=script&lang=js"
export * from "./DataLoading.vue?vue&type=script&lang=js"

import "./DataLoading.vue?vue&type=style&index=0&id=ab537460&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__